import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SidebarDataType, initialSidebarData } from '../types';
import { useNavigate } from 'react-router-dom';

const termLinkDict = {
  paid: 'https://drive.google.com/file/d/1gDcNirX9wMrGmqIjG9a_dagkt-VCZjSU/view',
  free: 'https://drive.google.com/file/d/1KapVBdHIpGiYdgLy9SI8DnsuBuCwcg8w/view',
};

export const useSidebarData = (): SidebarDataType => {
  const [data, setData] = useState<SidebarDataType>(initialSidebarData);
  const { i18n } = useTranslation();
  const { language } = i18n;
  const navigate = useNavigate();

  useEffect(() => {
    setData({
      floodPrediction: [
        {
          title: 'common.menu.predictionMap',
          link: '/prediction/map',
        },
        {
          title: 'common.menu.alertSetting',
          link: '/prediction/new_alert',

          subNav: [
            {
              title: 'common.menu.addAlert',
              link: '/prediction/new_alert',
              id: "commonMenuNewAlert",
            },
            {
              title: 'common.menu.alertList',
              link: '/prediction/alerts',
            },
          ],
        },
        // 開発用のため、これは非表示
        // {
        //   title: 'common.menu.customer',
        //   link: '/prediction/customer',
        // },
      ],
      supports: [
        {
          title: 'common.menu.help',
          subNav: [
            {
              title: 'common.menu.helpUse',
              blank: true,
              // ゆくゆくは英語版を整備する
              link: `https://drive.google.com/file/d/1LNHdHDf-nEACIWONIszUFaEXYtvJ0m7I/view`,
            },
            {
              title: 'common.menu.helpDesc',
              blank: true,
              link: `https://drive.google.com/file/d/1KWqzC6zbV79wJc0adO7C-KWoOUSyWAqT/view`,
            },
            {
              title: 'common.menu.used',
              blank: true,
              link: termLinkDict.paid,
            },
            {
              title: 'common.menu.privacy',
              blank: true,
              link: 'https://drive.google.com/file/d/1KbzIo51t9kmEvri5IAxOfkVKsyUuZZVJ/view',
            },
            // {
            //   title: 'common.menu.info',
            //   link: '/prediction/contact',
            // },
            {
              title: 'common.menu.tutorial',
              link: '',
              callback: () => {
                navigate('/prediction/map');
                localStorage.setItem('tutorialStatus', '');
                window.dispatchEvent(new Event("tutorial-start"));
              },
            },
          ],
        },
      ],
      riskAssessment: [
        {
          title: 'common.menu.climate_vision',
          blank: true,
          link: 'https://climate-vision-atlas.gaia-vision.co.jp/',
        },
      ],
    });
  }, [language]);

  return data;
};
